export const baseUrl = "https://restcountries.com/v3.1";